import classNames from "classnames";
import {
  ALargeSmall,
  AlignCenter,
  AlignCenterHorizontal,
  AlignCenterVertical,
  AlignEndHorizontal,
  AlignEndVertical,
  AlignHorizontalSpaceAround,
  AlignJustify,
  AlignLeft,
  AlignRight,
  AlignStartHorizontal,
  AlignStartVertical,
  AlignVerticalSpaceAround,
  Archive,
  ArchiveRestore,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  ArrowUpRight,
  BadgeInfo,
  Bold,
  BrickWall,
  Building,
  Calendar,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Circle,
  CircleAlert,
  Clapperboard,
  Clock,
  CloudUpload,
  Coins,
  Cone,
  Copy,
  CopyPlus,
  DollarSign,
  Download,
  Droplets,
  Ellipsis,
  Expand,
  ExternalLink,
  Eye,
  EyeClosed,
  Focus,
  FolderOpen,
  Frame,
  Gauge,
  Group,
  Headset,
  Heart,
  HelpCircle,
  Home,
  Image,
  ImageOff,
  ImagePlus,
  Images,
  ImageUpscale,
  Infinity,
  Info,
  Italic,
  IterationCcw,
  Keyboard,
  LampCeiling,
  LampDesk,
  LassoSelect,
  Layers,
  LayoutDashboard,
  Library,
  LifeBuoy,
  Lightbulb,
  LoaderCircle,
  Lock,
  LogOut,
  Maximize,
  Menu,
  MessageCircle,
  MessageCircleHeart,
  Minus,
  MoreHorizontal,
  MousePointerClick,
  Paintbrush,
  Palette,
  Pause,
  Pen,
  PencilLine,
  PersonStanding,
  Pin,
  Pipette,
  Play,
  Plus,
  Proportions,
  Ratio,
  RectangleHorizontal,
  RectangleVertical,
  Redo,
  RefreshCcw,
  RefreshCw,
  RotateCw,
  Scissors,
  ScrollText,
  Search,
  Send,
  Settings,
  Settings2,
  Shapes,
  Shirt,
  ShoppingBasket,
  Sparkles,
  Spline,
  Square,
  SquarePen,
  SquarePlus,
  SquareRoundCorner,
  SquareStack,
  SquareUser,
  Star,
  Strikethrough,
  Tag,
  Trash,
  Trees,
  Triangle,
  TriangleAlert,
  Type,
  Underline,
  Upload,
  User,
  UserRound,
  Users,
  VectorSquare,
  Video,
  WandSparkles,
  X,
} from "lucide-react";
import type { SVGProps } from "react"; // FIXME: Not possible to resize the following icons, only in fixed sizes
// Need to check which ones are still used and if they are not supported by lucide-react
import { Tooltip, type TooltipProps } from "../Tooltip/Tooltip.tsx";
import { Bolt } from "./assets/Bolt.tsx";
import { DropletsCascade } from "./assets/DropletsCascade.tsx"; // https://lucide.dev/icons/
import { Facebook } from "./assets/Facebook.tsx";
import { GoogleAds } from "./assets/GoogleAds.tsx";
import { Invalid } from "./assets/Invalid.tsx";
import { OnboardingCenteredTip } from "./assets/OnboardingCenteredTip.tsx";
import { OnboardingCharacterAngle1 } from "./assets/OnboardingCharacterAngle1.tsx";
import { OnboardingCharacterAngle2 } from "./assets/OnboardingCharacterAngle2.tsx";
import { OnboardingNonCenteredTip } from "./assets/OnboardingNonCenteredTip.tsx";
import { OnboardingNoTextTip } from "./assets/OnboardingNoTextTip.tsx";
import { OnboardingObjectAngle1 } from "./assets/OnboardingObjectAngle1.tsx";
import { OnboardingObjectAngle2 } from "./assets/OnboardingObjectAngle2.tsx";
import { OnboardingSizeTip } from "./assets/OnboardingSizeTip.tsx";
import { PersonStandingCascade } from "./assets/PersonStandingCascade.tsx";
import { PimentoStar } from "./assets/PimentoStar.tsx";
import { Select } from "./assets/Select.tsx";
import { ShirtCascade } from "./assets/ShirtCascade.tsx";
import { Valid } from "./assets/Valid.tsx";
// https://lucide.dev/icons/
const IconsMap = {
  ALargeSmall,
  AlignCenter,
  AlignCenterHorizontal,
  AlignCenterVertical,
  AlignEndHorizontal,
  AlignEndVertical,
  AlignHorizontalSpaceAround,
  AlignJustify,
  AlignLeft,
  AlignRight,
  AlignStartHorizontal,
  AlignStartVertical,
  AlignVerticalSpaceAround,
  Archive,
  ArchiveRestore,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  ArrowUpRight,
  BadgeInfo,
  Bold,
  Bolt,
  BrickWall,
  Building,
  Calendar,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Circle,
  CircleAlert,
  Clapperboard,
  Clock,
  CloudUpload,
  Coins,
  Cone,
  Copy,
  CopyPlus,
  DollarSign,
  Droplets,
  DropletsCascade,
  Download,
  Ellipsis,
  Eye,
  EyeClosed,
  Expand,
  ExternalLink,
  Facebook,
  Focus,
  FolderOpen,
  Frame,
  Gauge,
  GoogleAds,
  Group,
  Headset,
  Heart,
  HelpCircle,
  Home,
  Image,
  ImageOff,
  ImagePlus,
  ImageUpscale,
  Images,
  Infinity,
  Info,
  Invalid,
  Italic,
  IterationCcw,
  Keyboard,
  LampCeiling,
  LampDesk,
  LassoSelect,
  Layers,
  LayoutDashboard,
  LifeBuoy,
  Lightbulb,
  LoaderCircle,
  Lock,
  LogOut,
  Library,
  Maximize,
  Menu,
  MessageCircle,
  MessageCircleHeart,
  Minus,
  MoreHorizontal,
  MousePointerClick,
  OnboardingCenteredTip,
  OnboardingCharacterAngle1,
  OnboardingCharacterAngle2,
  OnboardingNonCenteredTip,
  OnboardingNoTextTip,
  OnboardingObjectAngle1,
  OnboardingObjectAngle2,
  OnboardingSizeTip,
  Paintbrush,
  Palette,
  Pause,
  PersonStanding,
  PersonStandingCascade,
  PimentoStar,
  Pin,
  Play,
  Plus,
  Pen,
  PencilLine,
  Pipette,
  Proportions,
  Ratio,
  RectangleVertical,
  RectangleHorizontal,
  Redo,
  RefreshCw,
  RefreshCcw,
  RotateCw,
  Scissors,
  ScrollText,
  Search,
  Select,
  Send,
  Settings,
  Settings2,
  Shapes,
  Shirt,
  ShirtCascade,
  ShoppingBasket,
  Square,
  SquarePen,
  SquarePlus,
  SquareRoundCorner,
  SquareStack,
  SquareUser,
  Star,
  Strikethrough,
  Sparkles,
  Spline,
  Tag,
  Trash,
  Trees,
  Triangle,
  TriangleAlert,
  Type,
  Underline,
  Upload,
  User,
  UserRound,
  Users,
  Valid,
  VectorSquare,
  Video,
  WandSparkles,
  X,
};
export type IconName = keyof typeof IconsMap;
export type IconSize = keyof typeof iconSizeToSize;
export type IconProps = {
  name: IconName;
  size?: IconSize;
  tooltip?: Omit<TooltipProps, "children">;
  rotate?: number;
  className?: string;
} & Omit<SVGProps<SVGSVGElement>, "height" | "width" | "ref" | "key">;

export const Icon = ({
  name,
  size = "md",
  tooltip,
  rotate,
  style,
  className,
  ...rest
}: IconProps) => {
  const Comp = IconsMap[name];
  const iconProps = {
    style: {
      transform: rotate ? `rotate(${rotate}deg)` : undefined,
      ...style,
    },
    size: iconSizeToSize[size],
    ...rest,
  };
  if (tooltip) {
    return (
      <Tooltip
        {...{
          ...tooltip,
          className: classNames("max-w-[250px]", tooltip.className),
        }}
      >
        <Comp {...iconProps} className={classNames(strokeClass, className)} />
      </Tooltip>
    );
  }
  return <Comp {...iconProps} className={classNames(strokeClass, className)} />;
};

const iconSizeToSize = {
  xs: 12,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 28,
} as const;

const strokeClass = "stroke-lg";
